// extracted by mini-css-extract-plugin
export default {"align":"Informacion_align__DnNpK","section":"Informacion_section__edwy6"};